import React, { createContext, useContext, useState, useCallback } from 'react';

const RefreshContext = createContext(null);

export function RefreshProvider({ children }) {
  const [refreshCount, setRefreshCount] = useState(0);
  const [refreshing, setRefreshing] = useState(false);

  const triggerRefresh = useCallback(async () => {
    setRefreshing(true);
    setRefreshCount((c) => c + 1);
    // Give a brief visual indicator
    setTimeout(() => setRefreshing(false), 800);
  }, []);

  return (
    <RefreshContext.Provider value={{ refreshCount, refreshing, triggerRefresh }}>
      {children}
    </RefreshContext.Provider>
  );
}

export function useRefresh() {
  return useContext(RefreshContext);
}
